var map = {
	"./bg-vip0.png": "4cba",
	"./bg-vip1.png": "92cb",
	"./bg-vip2.png": "0a27",
	"./bg-vip3.png": "3562",
	"./bg-vip4.png": "fb94",
	"./bg-vip5.png": "ae27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f662";